import { environment } from "@environments";
import { Utils } from "./utils";

/** JWT local só para `environment.env === "mock"` (exp longe no futuro). */
const MOCK_ACCESS_TOKEN =
  "eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiJtb2NrLWp0aSIsImlhdCI6MTcyMDAwMDAwMCwiZXhwIjoxOTExMTU0NTg5LCJsb2dvbiI6IkM4MDIxMEEiLCJ1c2VyX2lkIjoibW9jay11c2VyIiwiYnVzaW5lc3NfdW5pdF9pZCI6InVuaXQxIiwiYXV0aG9yaXRpZXMiOlsiUk9MRV9EVF9MT0dPTlBPUlRBTFZDX0FETUlOTUFJTlRFTkFOQ0UiLCJST0xFX1VTRVIiLCJST0xFX0FVVEgtQkFTSUMiXX0.mock-signature";

export function isMockEnvironment(): boolean {
  return environment.env === "mock";
}

/**
 * Garante cookie de sessão para testar UI contra Mockoon / mock:start
 * sem minitoken do menu de produtos.
 */
export function ensureMockSession(): string {
  let token = Utils.getCookie("accessToken");
  if (!token) {
    Utils.setCookie("accessToken", MOCK_ACCESS_TOKEN);
    token = MOCK_ACCESS_TOKEN;
  }
  return token;
}
